import * as constants from '../../../constants';
import { Helper } from '../Helper';
export class ContinueHelper extends Helper {
    emit(sb, node, options) {
        let pc = options.continuePC;
        if (pc === undefined) {
            sb.context.reportUnsupported(node);
        }
        else {
            if (options.finallyPC !== undefined) {
                sb.emitPushInt(node, constants.FINALLY_COMPLETION);
            }
            sb.emitPushInt(node, constants.CONTINUE_COMPLETION);
            if (options.finallyPC !== undefined) {
                pc = options.finallyPC;
                sb.emitPushInt(node, constants.FINALLY_COMPLETION);
            }
            sb.emitJmp(node, 'JMP', pc);
        }
    }
}

//# sourceMappingURL=ContinueHelper.js.map
